import React, { useEffect, useRef, useContext, useState } from "react";
import styles from "./App.module.scss"; // Assuming you have CSS modules set up
import Context from "../../context/context"; // Assuming you have a Context set up
import useScript from "../../hooks/useScript";

import { questions } from "../../timestamp-questions.json";
import SwipeableNav from "../SwipeableNav/SwipeableNav";
import moment from "moment";
const App = () => {
  const videoRef = useRef(null);
  const [currentTime, setCurrentTime] = useState(0); // Assuming you want to keep track of the current time
  const { windowWidth, windowHeight } = useContext(Context); // Assuming these values are provided by your Context
  const [userScrolled, setUserScrolled] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [currentButtonIndex, setCurrentButtonIndex] = useState(activeIndex);
  useScript(
    "https://players.brightcove.net/1971571337001/IzQolWCsY_default/index.min.js"
  );

  useEffect(() => {
    // Check for analytics on mount
    window.appEventData = window.appEventData || [];

    const navElement = document.getElementById("nav");

    let scrollTimeout;

    // Create an interval to check the current time of the video every second
    let autoScrollInterval = setInterval(() => {
      const video = videojs("vjs_video_3_html5_api");
      setCurrentTime(video.currentTime());
    }, 1000);

    const handleScroll = (e) => {
      setUserScrolled(true);

      // ### This will get the current scrolled to item and set the index
      // ### so that when you click a button, it will scroll to the next correct item
      const scrollContainer = document.querySelector("#navList");
      const navItems = document.querySelectorAll("button[class*='nav-item']");
      let closestNavItem = null;
      let smallestDifference = Infinity;
      // Adjusting the reference point by subtracting 20px to include the offset
      const scrollPositionWithOffset = scrollContainer.scrollLeft + 60;
      let myIdx;
      navItems.forEach((item, index) => {
        const itemStart = item.offsetLeft;
        const itemEnd = itemStart + item.offsetWidth;
        // Check if the adjusted scroll position with offset is within the item's start and end
        if (
          scrollPositionWithOffset >= itemStart &&
          scrollPositionWithOffset <= itemEnd
        ) {
          const difference = Math.min(
            Math.abs(scrollPositionWithOffset - itemStart),
            Math.abs(scrollPositionWithOffset - itemEnd)
          );
          if (difference < smallestDifference) {
            smallestDifference = difference;
            closestNavItem = item;
            myIdx = index;
          }
        }
      });

      if (closestNavItem) {
        setCurrentButtonIndex(myIdx);
      }
    };

    // Add event listener to the nav element
    if (navElement) {
      navElement.addEventListener("wheel", handleScroll);
    }

    return () => {
      if (navElement) {
        navElement.removeEventListener("wheel", handleScroll);
      }
      clearInterval(autoScrollInterval);
      if (scrollTimeout) clearTimeout(scrollTimeout);
    };
  }, []);

  const handleTimestamp = (timestamp) => {
    const seconds = moment(timestamp, "mm:ss").diff(
      moment().startOf("day"),
      "seconds"
    );
    const video = videojs("vjs_video_3_html5_api");
    if (video) {
      video.currentTime(seconds);
      video.play();
    }
  };

  return (
    <Context.Provider value={{ windowWidth, windowHeight }}>
      <div className={styles.app}>
        <div className={styles.video}>
          <div className={styles.wrapperWithBorder}>
            <video
              ref={videoRef}
              className="video-js vjs-fluid vjs-default-skin vjs-controls-enabled vjs-workinghover vjs-v8 vjs-layout-x-large bc-player-IzQolWCsY_default bc-player-IzQolWCsY_default-index-0 vjs-mouse vjs-plugins-ready vjs-player-info vjs-contextmenu-ui vjs-viewability vjs-errors vjs-has-started vjs-paused vjs-hide-controls vjs-user-inactive"
              data-account="1971571337001"
              data-player="IzQolWCsY"
              data-embed="default"
              controls
              data-video-id="6358436370112"
              data-playlist-id=""
              data-application-id=""
              muted
            ></video>
            <SwipeableNav
              items={questions}
              handleTimestamp={handleTimestamp}
              currentTime={currentTime}
              userScrolled={userScrolled}
              setUserScrolled={setUserScrolled}
              activeIndex={activeIndex}
              setActiveIndex={setActiveIndex}
              currentButtonIndex={currentButtonIndex}
              setCurrentButtonIndex={setCurrentButtonIndex}
            />
          </div>
        </div>
      </div>
    </Context.Provider>
  );
};

export default App;
